import { Box } from "@mui/material";
import PropTypes from "prop-types";
import "./lessonsOfCourse.css";

const LessonsOfCourse = ({ course }) => {
  LessonsOfCourse.propTypes = {
    course: PropTypes.object,
  };
  return (
    <Box sx={{ display: "flex", position: "relative" }}>
      <section class="html-course course-section">
        <div class="courses">
          {course.lessons.map((lesson, i) => (
            <div class="course html" key={lesson.id} tabindex="1">
              <div class="course-info">
                <span>درس</span>
                <h5>{lesson.name}</h5>
              </div>
              <div class="course-more">
                <div class="details">
                  <h5>{`درس ${i + 1}`}</h5>
                  {/* <span class="time">4 min.</span> */}
                </div>
                <p class="description">{lesson.description}</p>
                {/* <button class="read-btn mark" tabindex="2">
                Mark as Incomplete
              </button>
              <a class="read-btn" tabindex="3">
                Read
              </a> */}
              </div>
            </div>
          ))}
        </div>
      </section>
    </Box>
  );
};

export default LessonsOfCourse;
